// C:\Projects\texe-web\src\components\UserListItem.tsx
import { Link } from "react-router-dom";
import Avatar from "./Avatar";
import FollowButton from "./FollowButton";
import { API_BASE_URL } from "../lib/api";
import type { UserSearchItem } from "../lib/userSearchApi";

function abs(url?: string | null) {
  if (!url) return undefined;
  return url.startsWith("/") ? `${API_BASE_URL}${url}` : url;
}

export default function UserListItem({ u }: { u: UserSearchItem }) {
  const small = abs(u.avatarUrlSmall || u.avatarUrl);

  return (
    <li
      style={{
        listStyle: "none",
        border: "1px solid #222",
        borderRadius: 10,
        padding: 10,
        display: "grid",
        gridTemplateColumns: "36px 1fr auto",
        gap: 10,
        alignItems: "center",
        background: "#0b0b0b",
      }}
    >
      <Link to={`/u/${encodeURIComponent(u.username)}`} title={`@${u.username}`}>
        <Avatar src={small} alt={u.username} size={36} />
      </Link>

      <div style={{ minWidth: 0 }}>
        <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
          <Link
            to={`/u/${encodeURIComponent(u.username)}`}
            style={{ textDecoration: "none", color: "inherit", fontWeight: 700 }}
          >
            @{u.username}
          </Link>
        </div>
        {u.bio && (
          <div
            style={{
              marginTop: 4,
              opacity: 0.8,
              fontSize: 12,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
            title={u.bio || undefined}
          >
            {u.bio}
          </div>
        )}
      </div>

      <div>
        {/* FollowButton artık size="sm" destekliyor (aşağıdaki dosyada güncelledik) */}
        <FollowButton userId={u.id} username={u.username} size="sm" />
      </div>
    </li>
  );
}
